// Split out of `shared.ts` so consumers can pull just these without dragging the zod-heavy barrel into a bundle.

export const locales = ['es-ES', 'ca-ES', 'en-US', 'pt-BR'] as const

export type Locale = (typeof locales)[number]

export const isLocale = (value: unknown): value is Locale =>
  typeof value === 'string' && (locales as readonly string[]).includes(value)

// Implements the parts of RFC 9110 we use: comma-separated entries, `;q=` weights, exact + language-prefix match.
export function parseLocale(headers: Record<string, string | string[] | undefined>): Locale {
  const raw = headers['accept-language']
  const value = Array.isArray(raw) ? raw[0] : raw
  if (!value) return 'es-ES'

  const tags: { tag: string; q: number }[] = []
  for (const part of value.split(',')) {
    const [lang, ...params] = part.trim().split(';')
    if (!lang) continue
    let q = 1
    for (const p of params) {
      const m = /q=([\d.]+)/.exec(p.trim())
      if (m?.[1]) q = parseFloat(m[1])
    }
    tags.push({ tag: lang.toLowerCase(), q })
  }
  tags.sort((a, b) => b.q - a.q)

  for (const { tag } of tags) {
    const exact = locales.find((l) => l.toLowerCase() === tag)
    if (exact) return exact
    const prefix = tag.split('-')[0]
    const prefixMatch = locales.find((l) => l.toLowerCase().startsWith(`${prefix}-`))
    if (prefixMatch) return prefixMatch
  }
  return 'es-ES'
}
